export default __webpack_public_path__ + "static/media/cr8ed-demo.3e1f2ade.gif";